"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocaleString = getLocaleString;
exports.localize = localize;
Object.defineProperty(exports, "getRTLList", {
  enumerable: true,
  get: function get() {
    return _getRTLList.default;
  }
});
exports.default = void 0;

var _getLocaleString = _interopRequireDefault(require("./getLocaleString"));

var _getAllLocalizedStrings = _interopRequireDefault(require("./getAllLocalizedStrings"));

var _getRTLList = _interopRequireDefault(require("./getRTLList"));

var _useLocalizer = _interopRequireDefault(require("../hooks/useLocalizer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var deprecationNotesShown;

function localize(id, language) {
  if (!deprecationNotesShown) {
    console.warn('botframework-webchat: localize() is deprecated. Please use the useLocalizer() hooks instead. This function will be removed on or after 2022-02-12.');
    deprecationNotesShown = true;
  }

  var allStrings = (0, _getAllLocalizedStrings.default)();
  var localizedStrings = allStrings[language];

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return Object.entries(args).reduce(function (str, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        index = _ref2[0],
        arg = _ref2[1];

    return str.replace("$".concat(+index + 1), arg);
  }, localizedStrings && localizedStrings[id] || allStrings['en-US'][id] || '');
}

function getLocaleString() {
  if (!deprecationNotesShown) {
    console.warn('botframework-webchat: localize() is deprecated. Please use the useLocalizer() hooks instead. This function will be removed on or after 2022-02-12.');
    deprecationNotesShown = true;
  }

  return _getLocaleString.default.apply(void 0, arguments);
}

var _default = function _default(_ref3) {
  var args = _ref3.args,
      text = _ref3.text;

  if (!deprecationNotesShown) {
    console.warn('botframework-webchat: <Localize> is deprecated. Please use the useLocalizer() hooks instead. This function will be removed on or after 2022-02-12.');
    deprecationNotesShown = true;
  }

  return (0, _useLocalizer.default)().apply(void 0, [text].concat(_toConsumableArray(args || [])));
};

exports.default = _default;